import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from 'react'
import PropTypes from 'prop-types'

import { AppContext } from '~/app/providers/App'
import { usePostsContext } from '~/modules/post/context'
import { getNextUnprocessedPost } from '~/modules/post/utils'
import { useCurrentPost } from '~/app/state/hooks'
import { usePost } from '~/modules/post/hooks'
import { useTrackPostSelected } from '~/shared/hooks/tracking'
import { getAppURL } from '~/shared/utils'
import { LoadMore } from '~/shared/components'
import { SERVICE_DEFAULTS } from '~/app/constants'

import { Wrapper } from './styles'
import Grid from './Grid'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'posts' implicitly has an 'any' type.
function addFallbackImage(posts, service) {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const { images } = SERVICE_DEFAULTS[service] || SERVICE_DEFAULTS.instagram

  let count = 0
  // @ts-expect-error TS(7006) FIXME: Parameter 'post' implicitly has an 'any' type.
  return posts.map((post) => ({
    data: post,
    fallbackImg: post.mediaUrl ? null : images[count++ % images.length],
  }))
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'channel' implicitly has an 'any' ... Remove this comment to see the full error message
const Container = ({ channel }) => {
  // @ts-ignore
  const [{ posts, loading, loadedAll }, { loadMore }] = usePostsContext()

  const [extendedPosts, setExtendedPosts] = useState(null)

  const wrapperRef = useRef(null)

  // @ts-expect-error TS(2339) FIXME: Property 'filter' does not exist on type 'unknown'... Remove this comment to see the full error message
  const { filter, onClearFilter } = useContext(AppContext)

  const [unprocessedPostDisplayed, setUnprocessedPostDisplayed] =
    useState(false)

  const { queryPost } = usePost()
  const trackPostSelected = useTrackPostSelected()

  const { currentPost, queryCurrentPost, mutateCurrentPost } = useCurrentPost()

  useEffect(() => {
    queryCurrentPost()
  }, [])

  useEffect(() => {
    if (currentPost?.engageCompleted) {
      selectNextPost()
    }
  }, [currentPost])

  useEffect(() => {
    if (!posts || !channel) return
    const result = addFallbackImage(posts, channel.service)
    setExtendedPosts(result)
  }, [posts])

  useEffect(() => {
    if (!channel || !currentPost) return

    if (currentPost.channelId !== channel.serviceId) {
      mutateCurrentPost(null)
      setExtendedPosts(null)
    }
  }, [channel])

  useEffect(() => {
    // @ts-expect-error TS(2339) FIXME: Property 'length' does not exist on type 'never'.
    if (!extendedPosts?.length) return

    const channelBackfilling = !channel?.backfillingComplete

    if (!currentPost || (channelBackfilling && !unprocessedPostDisplayed)) {
      if (wrapperRef?.current) {
        // @ts-expect-error TS(2339) FIXME: Property 'scrollTop' does not exist on type 'never... Remove this comment to see the full error message
        wrapperRef.current.scrollTop = 0
      }

      const nextPost = selectNextPost()
      // @ts-expect-error TS(2339) FIXME: Property 'totalPendingComments' does not exist on ... Remove this comment to see the full error message
      if (nextPost?.totalPendingComments > 0) {
        setUnprocessedPostDisplayed(true)
      }
    }
  }, [extendedPosts])

  const selectNextPost = useCallback(() => {
    // @ts-expect-error TS(2339) FIXME: Property 'length' does not exist on type 'never'.
    if (!extendedPosts?.length) return null
    const { data, fallbackImg } =
      getNextUnprocessedPost(extendedPosts) || extendedPosts[0]
    // @ts-expect-error TS(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
    mutateCurrentPost({ ...data, fallbackImg })
    return data
  }, [extendedPosts])

  const onRefresh = useCallback(
    (postId: string) => {
      queryPost({ variables: { id: postId, refreshMedia: true } })
    },
    [queryPost],
  )

  const onGoToPublish = useCallback(() => {
    // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
    window.location.href = getAppURL('publish')
  }, [])

  const onSelect = useCallback(
    (param: any) => {
      const { data, fallbackImg } = param
      mutateCurrentPost({ ...data, fallbackImg })
      trackPostSelected(data, filter)
    },
    [filter],
  )

  const isLoading = !channel || !channel.backfillingComplete || loading
  const counter = filter
    ? // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
      channel.labelsCount.find((el) => el.label === filter.value)
    : null

  return (
    <Wrapper ref={wrapperRef}>
      <Grid
        loading={isLoading}
        selected={currentPost?.id}
        posts={extendedPosts}
        service={channel?.service}
        filter={filter && counter ? { ...filter, count: counter.count } : null}
        handlers={{
          onSelect,
          onRefresh,
          onClearFilter,
          onGoToPublish,
        }}
      />
      {!loadedAll && (
        <LoadMore target={wrapperRef?.current} onLoad={loadMore} />
      )}
    </Wrapper>
  )
}

Container.propTypes = {
  channel: PropTypes.object,
}

export default Container
